import { Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import useDropDownStyles from './DropDown.styles';
import Tippy from '@tippyjs/react';

interface Props {
	id: string;
	title: string | React.ReactElement;
}

const DropDown: React.FC<React.PropsWithChildren<Props>> = ({ children, id, title }) => {
	const classes = useDropDownStyles();

	return (
		<div className={typeof title === 'string' ? classes.root : undefined} id={id}>
			<Tippy
				content={
					<div className={classes.listContainer} id={`${id}-tooltip`}>
						<div className={classes.tipy}>{children}</div>
					</div>
				}
				duration={[300, 0]}
				interactive={true}
				maxWidth={339}
				offset={[0, 0]}
				placement="bottom-start"
				zIndex={10}
			>
				{typeof title === 'string' ? (
					<div className={classes.titleContainer} id={`${id}-tooltip-toggle`}>
						<Typography
							fontFamily="Montserrat"
							fontSize={14}
							fontWeight={600}
							style={{ marginRight: 8 }}
						>
							{title}
						</Typography>
						<KeyboardArrowDown />
					</div>
				) : (
					title
				)}
			</Tippy>
		</div>
	);
};

export default DropDown;
